module.exports = __webpack_public_path__ + "img/palmar-hotel-5.312e2edd.jpg";